export default "/assets/340195831bed354a4b06d5198c679d2f.woff2";